import { NgModule } from '@angular/core';
import { UserAgent } from './user-agent.service';

@NgModule({
  providers: [UserAgent],
})
export class UserAgentModule {}
